import { render, staticRenderFns } from "./zhineng.vue?vue&type=template&id=690a5fd0&scoped=true&"
import script from "./zhineng.vue?vue&type=script&lang=ts&"
export * from "./zhineng.vue?vue&type=script&lang=ts&"
import style0 from "./zhineng.vue?vue&type=style&index=0&id=690a5fd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690a5fd0",
  null
  
)

export default component.exports